import { useState } from "react";
import Input from "./Input";

## Basic Usage

export function BasicInput() {
  const [value, setValue] = useState("");
  return <Input value={value} onChange={(e) => setValue(e.target.value)} placeholder="Enter text..." />;
}

<div style={{ maxWidth: "300px" }}>
  <BasicInput />
</div>

---

## Sizes

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "300px" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Medium:**</p>
    <Input inputSize="medium" placeholder="Medium input" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Medium Large:**</p>
    <Input inputSize="mediumLarge" placeholder="Medium large input" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Large (default):**</p>
    <Input inputSize="large" placeholder="Large input" />
  </div>
</div>

---

## Input Types

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "300px" }}>
  <Input type="text" placeholder="Text input" />
  <Input type="email" placeholder="Email input" />
  <Input type="password" placeholder="Password input" />
  <Input type="number" placeholder="Number input" />
</div>

---

## States

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "300px" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Success state:**</p>
    <Input inputState="success" defaultValue="Valid input" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Error state:**</p>
    <Input inputState="error" defaultValue="Invalid input" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Disabled:**</p>
    <Input disabled defaultValue="Disabled input" title="This field is disabled" />
  </div>
</div>

---

## With Validation

export function ValidationInput() {
  const [value, setValue] = useState("");
  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Enter email..."
      title="Email"
      required
      validate={(v) => {
        if (!v) return null;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v))) return "Please enter a valid email";
        return null;
      }}
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <p style={{ marginBottom: "0.5rem" }}>Type an invalid email and blur to see validation:</p>
  <ValidationInput />
</div>

---

## Transparent Style

<div style={{ background: "#f5f5f5", padding: "1rem", borderRadius: "8px", maxWidth: "300px" }}>
  <Input transparent placeholder="Transparent input on gray background" />
</div>

---

## Auto Focus and Auto Select

export function AutoFocusInput() {
  const [show, setShow] = useState(false);
  return (
    <div>
      <button onClick={() => setShow(!show)} style={{ marginBottom: "0.5rem" }}>
        {show ? "Hide" : "Show"} auto-focus input
      </button>
      {show && <Input autoFocus autoSelect defaultValue="This text is selected" />}
    </div>
  );
}

<div style={{ maxWidth: "300px" }}>
  <AutoFocusInput />
</div>

---

## Form Example

export function FormExample() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div>
        <label style={{ display: "block", marginBottom: "0.25rem", fontWeight: 500 }}>Name</label>
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" />
      </div>
      <div>
        <label style={{ display: "block", marginBottom: "0.25rem", fontWeight: 500 }}>Email</label>
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" />
      </div>
    </div>
  );
}

<div style={{ maxWidth: "300px" }}>
  <FormExample />
</div>


